import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from '../diegoftv00/diegoftv00.module.scss';

const Diegoftv00: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.diegoftv00}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles.links}>
                        <a
                            href="https://wa.me/5517988393564?text=Olá, gostaria de agendar uma aula."
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Agende sua aula</span>
                        </a>
                        <a
                            href="https://www.instagram.com/diegoftv00?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Instagram</span>
                        </a>
                        <a
                            href="https://maps.app.goo.gl/6K3uJRAeNxnRQVVF8"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Localização</span>
                        </a>
                        <Link to="/diegoftv00/horariosvalores" className={styles.linkGradient}>
                            <span>Horários e Valores</span>
                        </Link>
                        <Link to="/diegoftv00/torneio" className={styles.linkGradient}>
                            <span>Torneio</span>
                        </Link>
                    </div>
                    {/* <div className="mt-4">
                        <img width={120} src={require("./src/footer.png")} />
                    </div>
                    <p className={styles.footerText}>DIEGO SILVA</p> */}
                </div>
            </div>
        </div>
    );
};

export default Diegoftv00;
